export const ENTITY_LIST_REQUEST = 'ENTITY_LIST_REQUEST';
export const ENTITY_LIST_SUCCESS = 'ENTITY_LIST_SUCCESS';
export const ENTITY_LIST_CLEAR = 'ENTITY_LIST_CLEAR';
export const ENTITY_LIST_ERROR = 'ENTITY_LIST_ERROR';
export const ENTITY_UPSERT = 'ENTITY_UPSERT';
export const ENTITY_DELETE = 'ENTITY_DELETE'; 